/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Admins.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ChangeDoctorProductivityOverridesAdminApiInContract,
  CreateDoctorAdminApiInContract,
  DoctorAdminApiOutContract,
  DoctorLicenseAdminApiInContract,
  ErrorApiOutContract,
  ErrorDescription,
  GetProvidersScheduledParams,
  GetScheduledDoctorItemAdminApiOutContractPaginationItemCollectionApiOutContract,
  ImageApiOutContract,
  PutProvidersUserIdProfileimageBody,
  UpdateDoctorAdminApiInContract
} from '../pwrdbyQuickMDAdminsApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Returns 400 Bad Request when: email is invalid, name fields are invalid, professional titles are invalid, license details are invalid, productivity overrides are invalid, or a third-party service fails.
Returns 404 Not Found when a referenced visit type does not exist.
Returns 409 Conflict when a doctor with the same email or phone number already exists.
Returns 422 Unprocessable Entity when the phone number is invalid.
 * @summary Creates a new doctor (provider) in the system.
 */
export const postProviders = (
    createDoctorAdminApiInContract: CreateDoctorAdminApiInContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<DoctorAdminApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/providers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createDoctorAdminApiInContract, signal
    },
      options);
    }
  


export const getPostProvidersMutationOptions = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProviders>>, TError,{data: CreateDoctorAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postProviders>>, TError,{data: CreateDoctorAdminApiInContract}, TContext> => {

const mutationKey = ['postProviders'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProviders>>, {data: CreateDoctorAdminApiInContract}> = (props) => {
          const {data} = props ?? {};

          return  postProviders(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostProvidersMutationResult = NonNullable<Awaited<ReturnType<typeof postProviders>>>
    export type PostProvidersMutationBody = CreateDoctorAdminApiInContract
    export type PostProvidersMutationError = ErrorDescription | void | ErrorApiOutContract

    /**
 * @summary Creates a new doctor (provider) in the system.
 */
export const usePostProviders = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProviders>>, TError,{data: CreateDoctorAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postProviders>>,
        TError,
        {data: CreateDoctorAdminApiInContract},
        TContext
      > => {

      const mutationOptions = getPostProvidersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Retrieves a specific doctor by their user identifier.
 */
export const getProvidersUserId = (
    userId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<DoctorAdminApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/providers/${encodeURIComponent(String(userId))}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetProvidersUserIdInfiniteQueryKey = (userId?: string,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/providers/${userId}`
    ] as const;
    }

export const getGetProvidersUserIdQueryKey = (userId?: string,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/providers/${userId}`
    ] as const;
    }

    
export const getGetProvidersUserIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProvidersUserId>>>, TError = void | ErrorDescription | ErrorApiOutContract>(userId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProvidersUserIdInfiniteQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProvidersUserId>>> = ({ signal }) => getProvidersUserId(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProvidersUserIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProvidersUserId>>>
export type GetProvidersUserIdInfiniteQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetProvidersUserIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProvidersUserId>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProvidersUserId>>,
          TError,
          Awaited<ReturnType<typeof getProvidersUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProvidersUserIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProvidersUserId>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProvidersUserId>>,
          TError,
          Awaited<ReturnType<typeof getProvidersUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProvidersUserIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProvidersUserId>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a specific doctor by their user identifier.
 */

export function useGetProvidersUserIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProvidersUserId>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProvidersUserIdInfiniteQueryOptions(userId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves a specific doctor by their user identifier.
 */
export const prefetchGetProvidersUserIdInfiniteQuery = async <TData = Awaited<ReturnType<typeof getProvidersUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 queryClient: QueryClient, userId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetProvidersUserIdInfiniteQueryOptions(userId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetProvidersUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getProvidersUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProvidersUserIdQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProvidersUserId>>> = ({ signal }) => getProvidersUserId(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProvidersUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getProvidersUserId>>>
export type GetProvidersUserIdQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetProvidersUserId<TData = Awaited<ReturnType<typeof getProvidersUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProvidersUserId>>,
          TError,
          Awaited<ReturnType<typeof getProvidersUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProvidersUserId<TData = Awaited<ReturnType<typeof getProvidersUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProvidersUserId>>,
          TError,
          Awaited<ReturnType<typeof getProvidersUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProvidersUserId<TData = Awaited<ReturnType<typeof getProvidersUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a specific doctor by their user identifier.
 */

export function useGetProvidersUserId<TData = Awaited<ReturnType<typeof getProvidersUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProvidersUserIdQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves a specific doctor by their user identifier.
 */
export const prefetchGetProvidersUserIdQuery = async <TData = Awaited<ReturnType<typeof getProvidersUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 queryClient: QueryClient, userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetProvidersUserIdQueryOptions(userId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetProvidersUserIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProvidersUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProvidersUserIdQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProvidersUserId>>> = ({ signal }) => getProvidersUserId(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProvidersUserIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProvidersUserId>>>
export type GetProvidersUserIdSuspenseQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetProvidersUserIdSuspense<TData = Awaited<ReturnType<typeof getProvidersUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProvidersUserIdSuspense<TData = Awaited<ReturnType<typeof getProvidersUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProvidersUserIdSuspense<TData = Awaited<ReturnType<typeof getProvidersUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a specific doctor by their user identifier.
 */

export function useGetProvidersUserIdSuspense<TData = Awaited<ReturnType<typeof getProvidersUserId>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProvidersUserIdSuspenseQueryOptions(userId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetProvidersUserIdSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProvidersUserId>>>, TError = void | ErrorDescription | ErrorApiOutContract>(userId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProvidersUserIdInfiniteQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProvidersUserId>>> = ({ signal }) => getProvidersUserId(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProvidersUserIdSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProvidersUserId>>>
export type GetProvidersUserIdSuspenseInfiniteQueryError = void | ErrorDescription | ErrorApiOutContract


export function useGetProvidersUserIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProvidersUserId>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProvidersUserIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProvidersUserId>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProvidersUserIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProvidersUserId>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a specific doctor by their user identifier.
 */

export function useGetProvidersUserIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProvidersUserId>>>, TError = void | ErrorDescription | ErrorApiOutContract>(
 userId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersUserId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProvidersUserIdSuspenseInfiniteQueryOptions(userId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns 400 Bad Request when: email is invalid or cannot be modified, name fields are invalid, or professional titles are invalid.
Returns 404 Not Found when the doctor does not exist.
Returns 409 Conflict when the updated email or phone number conflicts with an existing doctor.
Returns 422 Unprocessable Entity when the phone number is invalid.
 * @summary Updates an existing doctor's details.
 */
export const putProvidersUserId = (
    userId: string,
    updateDoctorAdminApiInContract: UpdateDoctorAdminApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<DoctorAdminApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/providers/${encodeURIComponent(String(userId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateDoctorAdminApiInContract
    },
      options);
    }
  


export const getPutProvidersUserIdMutationOptions = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProvidersUserId>>, TError,{userId: string;data: UpdateDoctorAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putProvidersUserId>>, TError,{userId: string;data: UpdateDoctorAdminApiInContract}, TContext> => {

const mutationKey = ['putProvidersUserId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putProvidersUserId>>, {userId: string;data: UpdateDoctorAdminApiInContract}> = (props) => {
          const {userId,data} = props ?? {};

          return  putProvidersUserId(userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutProvidersUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof putProvidersUserId>>>
    export type PutProvidersUserIdMutationBody = UpdateDoctorAdminApiInContract
    export type PutProvidersUserIdMutationError = ErrorDescription | void | ErrorApiOutContract

    /**
 * @summary Updates an existing doctor's details.
 */
export const usePutProvidersUserId = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProvidersUserId>>, TError,{userId: string;data: UpdateDoctorAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putProvidersUserId>>,
        TError,
        {userId: string;data: UpdateDoctorAdminApiInContract},
        TContext
      > => {

      const mutationOptions = getPutProvidersUserIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns 403 Forbidden when the doctor has already been activated.
Returns 404 Not Found when the doctor does not exist.
 * @summary Deletes a doctor who has not yet been activated.
 */
export const deleteProvidersUserId = (
    userId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/providers/${encodeURIComponent(String(userId))}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteProvidersUserIdMutationOptions = <TError = void | ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProvidersUserId>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProvidersUserId>>, TError,{userId: string}, TContext> => {

const mutationKey = ['deleteProvidersUserId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProvidersUserId>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  deleteProvidersUserId(userId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProvidersUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProvidersUserId>>>
    
    export type DeleteProvidersUserIdMutationError = void | ErrorDescription | ErrorApiOutContract

    /**
 * @summary Deletes a doctor who has not yet been activated.
 */
export const useDeleteProvidersUserId = <TError = void | ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProvidersUserId>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProvidersUserId>>,
        TError,
        {userId: string},
        TContext
      > => {

      const mutationOptions = getDeleteProvidersUserIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns 400 Bad Request when: license number, state code, or DEA details are invalid, visit type count is invalid, or visit type visibility type is invalid.
Returns 404 Not Found when the doctor or a referenced visit type does not exist.
 * @summary Creates a new license for a doctor.
 */
export const postProvidersUserIdLicenses = (
    userId: string,
    doctorLicenseAdminApiInContract: DoctorLicenseAdminApiInContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<DoctorAdminApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/providers/${encodeURIComponent(String(userId))}/licenses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: doctorLicenseAdminApiInContract, signal
    },
      options);
    }
  


export const getPostProvidersUserIdLicensesMutationOptions = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProvidersUserIdLicenses>>, TError,{userId: string;data: DoctorLicenseAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postProvidersUserIdLicenses>>, TError,{userId: string;data: DoctorLicenseAdminApiInContract}, TContext> => {

const mutationKey = ['postProvidersUserIdLicenses'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProvidersUserIdLicenses>>, {userId: string;data: DoctorLicenseAdminApiInContract}> = (props) => {
          const {userId,data} = props ?? {};

          return  postProvidersUserIdLicenses(userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostProvidersUserIdLicensesMutationResult = NonNullable<Awaited<ReturnType<typeof postProvidersUserIdLicenses>>>
    export type PostProvidersUserIdLicensesMutationBody = DoctorLicenseAdminApiInContract
    export type PostProvidersUserIdLicensesMutationError = ErrorDescription | void | ErrorApiOutContract

    /**
 * @summary Creates a new license for a doctor.
 */
export const usePostProvidersUserIdLicenses = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProvidersUserIdLicenses>>, TError,{userId: string;data: DoctorLicenseAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postProvidersUserIdLicenses>>,
        TError,
        {userId: string;data: DoctorLicenseAdminApiInContract},
        TContext
      > => {

      const mutationOptions = getPostProvidersUserIdLicensesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Deletes all licenses from a doctor.
 */
export const deleteProvidersUserIdLicenses = (
    userId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<DoctorAdminApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/providers/${encodeURIComponent(String(userId))}/licenses`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteProvidersUserIdLicensesMutationOptions = <TError = void | ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProvidersUserIdLicenses>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProvidersUserIdLicenses>>, TError,{userId: string}, TContext> => {

const mutationKey = ['deleteProvidersUserIdLicenses'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProvidersUserIdLicenses>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  deleteProvidersUserIdLicenses(userId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProvidersUserIdLicensesMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProvidersUserIdLicenses>>>
    
    export type DeleteProvidersUserIdLicensesMutationError = void | ErrorDescription | ErrorApiOutContract

    /**
 * @summary Deletes all licenses from a doctor.
 */
export const useDeleteProvidersUserIdLicenses = <TError = void | ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProvidersUserIdLicenses>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProvidersUserIdLicenses>>,
        TError,
        {userId: string},
        TContext
      > => {

      const mutationOptions = getDeleteProvidersUserIdLicensesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns 400 Bad Request when: license number, state code, or DEA details are invalid, visit type count is invalid, or visit type visibility type is invalid.
Returns 404 Not Found when the doctor, license, or a referenced visit type does not exist.
 * @summary Updates an existing license for a doctor.
 */
export const putProvidersUserIdLicensesLicenseId = (
    userId: string,
    licenseId: string,
    doctorLicenseAdminApiInContract: DoctorLicenseAdminApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<DoctorAdminApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/providers/${encodeURIComponent(String(userId))}/licenses/${encodeURIComponent(String(licenseId))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: doctorLicenseAdminApiInContract
    },
      options);
    }
  


export const getPutProvidersUserIdLicensesLicenseIdMutationOptions = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProvidersUserIdLicensesLicenseId>>, TError,{userId: string;licenseId: string;data: DoctorLicenseAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putProvidersUserIdLicensesLicenseId>>, TError,{userId: string;licenseId: string;data: DoctorLicenseAdminApiInContract}, TContext> => {

const mutationKey = ['putProvidersUserIdLicensesLicenseId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putProvidersUserIdLicensesLicenseId>>, {userId: string;licenseId: string;data: DoctorLicenseAdminApiInContract}> = (props) => {
          const {userId,licenseId,data} = props ?? {};

          return  putProvidersUserIdLicensesLicenseId(userId,licenseId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutProvidersUserIdLicensesLicenseIdMutationResult = NonNullable<Awaited<ReturnType<typeof putProvidersUserIdLicensesLicenseId>>>
    export type PutProvidersUserIdLicensesLicenseIdMutationBody = DoctorLicenseAdminApiInContract
    export type PutProvidersUserIdLicensesLicenseIdMutationError = ErrorDescription | void | ErrorApiOutContract

    /**
 * @summary Updates an existing license for a doctor.
 */
export const usePutProvidersUserIdLicensesLicenseId = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProvidersUserIdLicensesLicenseId>>, TError,{userId: string;licenseId: string;data: DoctorLicenseAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putProvidersUserIdLicensesLicenseId>>,
        TError,
        {userId: string;licenseId: string;data: DoctorLicenseAdminApiInContract},
        TContext
      > => {

      const mutationOptions = getPutProvidersUserIdLicensesLicenseIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Deletes a specific license from a doctor.
 */
export const deleteProvidersUserIdLicensesLicenseId = (
    userId: string,
    licenseId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<DoctorAdminApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/providers/${encodeURIComponent(String(userId))}/licenses/${encodeURIComponent(String(licenseId))}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteProvidersUserIdLicensesLicenseIdMutationOptions = <TError = void | ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProvidersUserIdLicensesLicenseId>>, TError,{userId: string;licenseId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProvidersUserIdLicensesLicenseId>>, TError,{userId: string;licenseId: string}, TContext> => {

const mutationKey = ['deleteProvidersUserIdLicensesLicenseId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProvidersUserIdLicensesLicenseId>>, {userId: string;licenseId: string}> = (props) => {
          const {userId,licenseId} = props ?? {};

          return  deleteProvidersUserIdLicensesLicenseId(userId,licenseId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProvidersUserIdLicensesLicenseIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProvidersUserIdLicensesLicenseId>>>
    
    export type DeleteProvidersUserIdLicensesLicenseIdMutationError = void | ErrorDescription | ErrorApiOutContract

    /**
 * @summary Deletes a specific license from a doctor.
 */
export const useDeleteProvidersUserIdLicensesLicenseId = <TError = void | ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProvidersUserIdLicensesLicenseId>>, TError,{userId: string;licenseId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProvidersUserIdLicensesLicenseId>>,
        TError,
        {userId: string;licenseId: string},
        TContext
      > => {

      const mutationOptions = getDeleteProvidersUserIdLicensesLicenseIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns 400 Bad Request when a productivity override is invalid.
Returns 404 Not Found when the doctor or a referenced visit type does not exist.
 * @summary Creates and/or deletes productivity overrides for a doctor.
 */
export const putProvidersUserIdProductivityoverrides = (
    userId: string,
    changeDoctorProductivityOverridesAdminApiInContract: ChangeDoctorProductivityOverridesAdminApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<DoctorAdminApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/providers/${encodeURIComponent(String(userId))}/productivityoverrides`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: changeDoctorProductivityOverridesAdminApiInContract
    },
      options);
    }
  


export const getPutProvidersUserIdProductivityoverridesMutationOptions = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProvidersUserIdProductivityoverrides>>, TError,{userId: string;data: ChangeDoctorProductivityOverridesAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putProvidersUserIdProductivityoverrides>>, TError,{userId: string;data: ChangeDoctorProductivityOverridesAdminApiInContract}, TContext> => {

const mutationKey = ['putProvidersUserIdProductivityoverrides'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putProvidersUserIdProductivityoverrides>>, {userId: string;data: ChangeDoctorProductivityOverridesAdminApiInContract}> = (props) => {
          const {userId,data} = props ?? {};

          return  putProvidersUserIdProductivityoverrides(userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutProvidersUserIdProductivityoverridesMutationResult = NonNullable<Awaited<ReturnType<typeof putProvidersUserIdProductivityoverrides>>>
    export type PutProvidersUserIdProductivityoverridesMutationBody = ChangeDoctorProductivityOverridesAdminApiInContract
    export type PutProvidersUserIdProductivityoverridesMutationError = ErrorDescription | void | ErrorApiOutContract

    /**
 * @summary Creates and/or deletes productivity overrides for a doctor.
 */
export const usePutProvidersUserIdProductivityoverrides = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProvidersUserIdProductivityoverrides>>, TError,{userId: string;data: ChangeDoctorProductivityOverridesAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putProvidersUserIdProductivityoverrides>>,
        TError,
        {userId: string;data: ChangeDoctorProductivityOverridesAdminApiInContract},
        TContext
      > => {

      const mutationOptions = getPutProvidersUserIdProductivityoverridesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns 403 Forbidden when the operation is not allowed for the doctor's current state.
Returns 404 Not Found when the doctor does not exist.
 * @summary Activates a doctor's account.
 */
export const putProvidersUserIdActivate = (
    userId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/providers/${encodeURIComponent(String(userId))}/activate`, method: 'PUT'
    },
      options);
    }
  


export const getPutProvidersUserIdActivateMutationOptions = <TError = void | ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProvidersUserIdActivate>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putProvidersUserIdActivate>>, TError,{userId: string}, TContext> => {

const mutationKey = ['putProvidersUserIdActivate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putProvidersUserIdActivate>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  putProvidersUserIdActivate(userId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutProvidersUserIdActivateMutationResult = NonNullable<Awaited<ReturnType<typeof putProvidersUserIdActivate>>>
    
    export type PutProvidersUserIdActivateMutationError = void | ErrorDescription | ErrorApiOutContract

    /**
 * @summary Activates a doctor's account.
 */
export const usePutProvidersUserIdActivate = <TError = void | ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProvidersUserIdActivate>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putProvidersUserIdActivate>>,
        TError,
        {userId: string},
        TContext
      > => {

      const mutationOptions = getPutProvidersUserIdActivateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns 403 Forbidden when the operation is not allowed for the doctor's current state.
Returns 404 Not Found when the doctor does not exist.
 * @summary Deactivates a doctor's account.
 */
export const putProvidersUserIdDeactivate = (
    userId: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/providers/${encodeURIComponent(String(userId))}/deactivate`, method: 'PUT'
    },
      options);
    }
  


export const getPutProvidersUserIdDeactivateMutationOptions = <TError = void | ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProvidersUserIdDeactivate>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putProvidersUserIdDeactivate>>, TError,{userId: string}, TContext> => {

const mutationKey = ['putProvidersUserIdDeactivate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putProvidersUserIdDeactivate>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  putProvidersUserIdDeactivate(userId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutProvidersUserIdDeactivateMutationResult = NonNullable<Awaited<ReturnType<typeof putProvidersUserIdDeactivate>>>
    
    export type PutProvidersUserIdDeactivateMutationError = void | ErrorDescription | ErrorApiOutContract

    /**
 * @summary Deactivates a doctor's account.
 */
export const usePutProvidersUserIdDeactivate = <TError = void | ErrorDescription | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProvidersUserIdDeactivate>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putProvidersUserIdDeactivate>>,
        TError,
        {userId: string},
        TContext
      > => {

      const mutationOptions = getPutProvidersUserIdDeactivateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns 400 Bad Request when the image is invalid.
Returns 404 Not Found when the doctor does not exist.
 * @summary Uploads or removes a doctor's profile image.
 */
export const putProvidersUserIdProfileimage = (
    userId: string,
    putProvidersUserIdProfileimageBody: PutProvidersUserIdProfileimageBody,
 options?: SecondParameter<typeof fetcher>,) => {
      
      const formData = new FormData();
if(putProvidersUserIdProfileimageBody.image !== undefined) {
 formData.append(`image`, putProvidersUserIdProfileimageBody.image)
 }

      return fetcher<ImageApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/providers/${encodeURIComponent(String(userId))}/profileimage`, method: 'PUT',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getPutProvidersUserIdProfileimageMutationOptions = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProvidersUserIdProfileimage>>, TError,{userId: string;data: PutProvidersUserIdProfileimageBody}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putProvidersUserIdProfileimage>>, TError,{userId: string;data: PutProvidersUserIdProfileimageBody}, TContext> => {

const mutationKey = ['putProvidersUserIdProfileimage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putProvidersUserIdProfileimage>>, {userId: string;data: PutProvidersUserIdProfileimageBody}> = (props) => {
          const {userId,data} = props ?? {};

          return  putProvidersUserIdProfileimage(userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutProvidersUserIdProfileimageMutationResult = NonNullable<Awaited<ReturnType<typeof putProvidersUserIdProfileimage>>>
    export type PutProvidersUserIdProfileimageMutationBody = PutProvidersUserIdProfileimageBody
    export type PutProvidersUserIdProfileimageMutationError = ErrorDescription | void | ErrorApiOutContract

    /**
 * @summary Uploads or removes a doctor's profile image.
 */
export const usePutProvidersUserIdProfileimage = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProvidersUserIdProfileimage>>, TError,{userId: string;data: PutProvidersUserIdProfileimageBody}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putProvidersUserIdProfileimage>>,
        TError,
        {userId: string;data: PutProvidersUserIdProfileimageBody},
        TContext
      > => {

      const mutationOptions = getPutProvidersUserIdProfileimageMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns 400 Bad Request when the email is invalid or the account is already verified.
Returns 404 Not Found when the doctor does not exist.
 * @summary Resends the verification email to a doctor who has not yet verified their account.
 */
export const postProvidersUserIdResendverificationemail = (
    userId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/providers/${encodeURIComponent(String(userId))}/resendverificationemail`, method: 'POST', signal
    },
      options);
    }
  


export const getPostProvidersUserIdResendverificationemailMutationOptions = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProvidersUserIdResendverificationemail>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postProvidersUserIdResendverificationemail>>, TError,{userId: string}, TContext> => {

const mutationKey = ['postProvidersUserIdResendverificationemail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProvidersUserIdResendverificationemail>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  postProvidersUserIdResendverificationemail(userId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostProvidersUserIdResendverificationemailMutationResult = NonNullable<Awaited<ReturnType<typeof postProvidersUserIdResendverificationemail>>>
    
    export type PostProvidersUserIdResendverificationemailMutationError = ErrorDescription | void | ErrorApiOutContract

    /**
 * @summary Resends the verification email to a doctor who has not yet verified their account.
 */
export const usePostProvidersUserIdResendverificationemail = <TError = ErrorDescription | void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProvidersUserIdResendverificationemail>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postProvidersUserIdResendverificationemail>>,
        TError,
        {userId: string},
        TContext
      > => {

      const mutationOptions = getPostProvidersUserIdResendverificationemailMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns 400 Bad Request when pagination or date range parameters are invalid.
 * @summary Retrieves a paginated collection of scheduled doctors, optionally filtered by date range, search term, state, or visit types.
 */
export const getProvidersScheduled = (
    params?: GetProvidersScheduledParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<GetScheduledDoctorItemAdminApiOutContractPaginationItemCollectionApiOutContract>(
      {url: `https://admins-api.api.quick.md/api/v1/providers/scheduled`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetProvidersScheduledInfiniteQueryKey = (params?: GetProvidersScheduledParams,) => {
    return [
    'infinite', `https://admins-api.api.quick.md/api/v1/providers/scheduled`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetProvidersScheduledQueryKey = (params?: GetProvidersScheduledParams,) => {
    return [
    `https://admins-api.api.quick.md/api/v1/providers/scheduled`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetProvidersScheduledInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProvidersScheduled>>>, TError = ErrorDescription | void | ErrorApiOutContract>(params?: GetProvidersScheduledParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProvidersScheduledInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProvidersScheduled>>> = ({ signal }) => getProvidersScheduled(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProvidersScheduledInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProvidersScheduled>>>
export type GetProvidersScheduledInfiniteQueryError = ErrorDescription | void | ErrorApiOutContract


export function useGetProvidersScheduledInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProvidersScheduled>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params: undefined |  GetProvidersScheduledParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProvidersScheduled>>,
          TError,
          Awaited<ReturnType<typeof getProvidersScheduled>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProvidersScheduledInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProvidersScheduled>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetProvidersScheduledParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProvidersScheduled>>,
          TError,
          Awaited<ReturnType<typeof getProvidersScheduled>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProvidersScheduledInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProvidersScheduled>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetProvidersScheduledParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a paginated collection of scheduled doctors, optionally filtered by date range, search term, state, or visit types.
 */

export function useGetProvidersScheduledInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProvidersScheduled>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetProvidersScheduledParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProvidersScheduledInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves a paginated collection of scheduled doctors, optionally filtered by date range, search term, state, or visit types.
 */
export const prefetchGetProvidersScheduledInfiniteQuery = async <TData = Awaited<ReturnType<typeof getProvidersScheduled>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetProvidersScheduledParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetProvidersScheduledInfiniteQueryOptions(params,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetProvidersScheduledQueryOptions = <TData = Awaited<ReturnType<typeof getProvidersScheduled>>, TError = ErrorDescription | void | ErrorApiOutContract>(params?: GetProvidersScheduledParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProvidersScheduledQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProvidersScheduled>>> = ({ signal }) => getProvidersScheduled(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProvidersScheduledQueryResult = NonNullable<Awaited<ReturnType<typeof getProvidersScheduled>>>
export type GetProvidersScheduledQueryError = ErrorDescription | void | ErrorApiOutContract


export function useGetProvidersScheduled<TData = Awaited<ReturnType<typeof getProvidersScheduled>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params: undefined |  GetProvidersScheduledParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProvidersScheduled>>,
          TError,
          Awaited<ReturnType<typeof getProvidersScheduled>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProvidersScheduled<TData = Awaited<ReturnType<typeof getProvidersScheduled>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetProvidersScheduledParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProvidersScheduled>>,
          TError,
          Awaited<ReturnType<typeof getProvidersScheduled>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProvidersScheduled<TData = Awaited<ReturnType<typeof getProvidersScheduled>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetProvidersScheduledParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a paginated collection of scheduled doctors, optionally filtered by date range, search term, state, or visit types.
 */

export function useGetProvidersScheduled<TData = Awaited<ReturnType<typeof getProvidersScheduled>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetProvidersScheduledParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProvidersScheduledQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Retrieves a paginated collection of scheduled doctors, optionally filtered by date range, search term, state, or visit types.
 */
export const prefetchGetProvidersScheduledQuery = async <TData = Awaited<ReturnType<typeof getProvidersScheduled>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetProvidersScheduledParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetProvidersScheduledQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetProvidersScheduledSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProvidersScheduled>>, TError = ErrorDescription | void | ErrorApiOutContract>(params?: GetProvidersScheduledParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProvidersScheduledQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProvidersScheduled>>> = ({ signal }) => getProvidersScheduled(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProvidersScheduledSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProvidersScheduled>>>
export type GetProvidersScheduledSuspenseQueryError = ErrorDescription | void | ErrorApiOutContract


export function useGetProvidersScheduledSuspense<TData = Awaited<ReturnType<typeof getProvidersScheduled>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params: undefined |  GetProvidersScheduledParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProvidersScheduledSuspense<TData = Awaited<ReturnType<typeof getProvidersScheduled>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetProvidersScheduledParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProvidersScheduledSuspense<TData = Awaited<ReturnType<typeof getProvidersScheduled>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetProvidersScheduledParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a paginated collection of scheduled doctors, optionally filtered by date range, search term, state, or visit types.
 */

export function useGetProvidersScheduledSuspense<TData = Awaited<ReturnType<typeof getProvidersScheduled>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetProvidersScheduledParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProvidersScheduledSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetProvidersScheduledSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProvidersScheduled>>>, TError = ErrorDescription | void | ErrorApiOutContract>(params?: GetProvidersScheduledParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProvidersScheduledInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProvidersScheduled>>> = ({ signal }) => getProvidersScheduled(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProvidersScheduledSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProvidersScheduled>>>
export type GetProvidersScheduledSuspenseInfiniteQueryError = ErrorDescription | void | ErrorApiOutContract


export function useGetProvidersScheduledSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProvidersScheduled>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params: undefined |  GetProvidersScheduledParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProvidersScheduledSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProvidersScheduled>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetProvidersScheduledParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProvidersScheduledSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProvidersScheduled>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetProvidersScheduledParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a paginated collection of scheduled doctors, optionally filtered by date range, search term, state, or visit types.
 */

export function useGetProvidersScheduledSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProvidersScheduled>>>, TError = ErrorDescription | void | ErrorApiOutContract>(
 params?: GetProvidersScheduledParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getProvidersScheduled>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProvidersScheduledSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




